module.exports = __webpack_public_path__ + "img/rice.d2f8eede.png";